import React, { useCallback, useEffect, useState } from 'react'
import { Icon } from 'semantic-ui-react'
import './deliveryTerms.css'
import { useDispatch, useSelector } from 'react-redux'
import { getSearchDropdownValues } from '../../../api/getGBForm'
import { updatedeliveryTransportField } from '../../../actions'
import { useCurrentShipmentType } from '../../../../hooks/useCurrentShipmentType'
import { useDebounce } from '../../../../hooks'
export default function UnlocodeField(props) {
  const dispatch = useDispatch()
  const { saveDeliveryTransport } = props
  const { id, unlocode } = useSelector((state) => state.Shipment.transportation.deliveryTerms)
  const {countryOfDestination} = useSelector((state)=>state.Shipment.transportation)
  const [unlocList, setUnlocList] = useState([])
  const getUnlocDropdownValues = useCallback(
    async (value) => {
      let payload = {
        eventType: 'GET_ENTITY_LIST',
        searchFilter: value,
        entityType: 'PORT',
        condition:countryOfDestination || " ",
        type: 'CDS'
      }
      let response = await getSearchDropdownValues(payload)
      response = response?.data?.eventMessage?.ports?.list || []
      setUnlocList(response)
    },
    [unlocode]
  )

  const currShipData = useCurrentShipmentType();
  const {isDisabled} = currShipData || {}

  const debouncedValue = useDebounce(unlocode,1000)
  useEffect(()=>{
    getUnlocDropdownValues(debouncedValue)
  },[debouncedValue])

 
  
  return (
    <>
      <div className='unlc-div'>
        <input
          onChange={(e) => {
            let value = e.target.value
            dispatch(updatedeliveryTransportField({ fieldName: 'unlocode', value }))
          }}
          list='unlocData'
          name='unlocData'
          value={unlocode}
          id='unlocDatas'
          disabled={isDisabled}
          onBlur={(e) => {
            let value = e.target.value
            saveDeliveryTransport(id, 'unlocode', value)
          }}
        />
        <datalist id='unlocData'>
          {unlocList.length > 0 &&
            unlocList.map((item) => (
              <option
                key={item.payload}
                value={item.portUnloc}
              >{`${item.portUnloc}-${item.portName}`}</option>
            ))}
        </datalist>

        <Icon name={'search'} className='unlc-search' />
      </div>
    </>
  )
}
